import { Injectable } from '@angular/core';
import { useGetAllQuery } from './downloads.api';

@Injectable({
    providedIn: 'root'
})
export class DownloadsApiFacade {
    public getAll$ = useGetAllQuery;
}
